// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title--p__iH{margin-bottom:8px}.error--JqaWZ{margin-bottom:32px}\n", "",{"version":3,"sources":["webpack://./../src/components/modals/ErrorModal/errorModal.module.scss"],"names":[],"mappings":"AAOA,cACC,iBAAkB,CAClB,cAGA,kBAAmB","sourcesContent":["\n\t\t\t\t\t\t\t\t@import \"~forly-kit/dist/_colors.scss\";\n\t\t\t\t\t\t\t\t@import \"styles/_typograph.scss\";\n\t\t\t\t\t\t\t\n.wrapper {\n}\n\n.title {\n\tmargin-bottom: 8px;\n}\n\n.error {\n\tmargin-bottom: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": "title--p__iH",
	"error": "error--JqaWZ"
};
export default ___CSS_LOADER_EXPORT___;
